import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Reflux from 'reflux';
import configurationStore from '../stores/configuration-store';
import facetStore from '../stores/accessory-facet-store';
import actions from '../actions';

import Wizard from './wizard';

const l = configurationStore.getLocalization.bind(configurationStore);
const ID = 'accessory';

export default createReactClass({

	displayName: 'ItemWizard',

	propTypes: {
		itemCount: PropTypes.number
	},

	mixins: [
		Reflux.listenTo(facetStore, 'onFacetChange', 'onFacetChange')
	],

	getInitialState() {
		return {
			facets: []
		};
	},

	onFacetChange(data) {
		this.setState({facets: data.facets});
	},

	render() {
		const attributes = {
			id: ID,
			title: l('specifyAccessory'),
			subtitle: l('specifyAccessorySub'),
			facets: this.state.facets,
			onSelectProperty: actions.selectAccessoryProperty.bind(actions),
			itemCount: this.props.itemCount,
			active: this.props.itemCount > 0,
			isAccessory: true
		};
		return (
			<Wizard {...attributes} />
		);
	}
});
